/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createExportInternal} from '../api'

export const useMutationCreateExportInternal = createReactQueryMutationHook('createExportInternal', createExportInternal)
